import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { GlobalFeatureNameSpaceNotary } from '../../../common/globalNotary'
import ApiService from '../../../common/ApiCalls'

// compound async logic should go through middleware, the resolve/reject status need to be separate actions
export const consumerDataFetch = createAction(
  GlobalFeatureNameSpaceNotary.DYNAMIC_TABS + '/ConsumerDataFetch'
)

export const consumerDataFetchSuccess = createAction(
  GlobalFeatureNameSpaceNotary.DYNAMIC_TABS + '/ConsumerDataFetchSuccess'
)

export const providerDataFetch = createAction(
  GlobalFeatureNameSpaceNotary.DYNAMIC_TABS + '/ProviderDataFetch'
)

export const providerDataFetchSuccess = createAction(
  GlobalFeatureNameSpaceNotary.DYNAMIC_TABS + '/ProviderDataFetchSuccess'
)

export const validationErrorChange = createAction(
  GlobalFeatureNameSpaceNotary.DYNAMIC_TABS + '/ValidationErrorChange'
)

export const consumerDataUpdate = createAsyncThunk(
  GlobalFeatureNameSpaceNotary.DYNAMIC_TABS + '/ConsumerDataUpdate',
  async pack => {
    const res = await ApiService().updateTabView(
      pack.id,
      pack.tabName,
      pack.updatedValues
    )
    console.log(res)
  }
)

export const providerDataUpdate = createAsyncThunk(
  GlobalFeatureNameSpaceNotary.DYNAMIC_TABS + '/ProviderDataUpdate',
  async pack => {
    const res = await ApiService().updateTabLayout(
      pack.tabName,
      pack.updatedValues
    )
    console.log(res)
  }
)

export const consumerDataFetchFailure = createAction(
  GlobalFeatureNameSpaceNotary.DYNAMIC_TABS + '/ConsumerDataFetchFailure'
)

// simple fetches should go through createAsyncThunk, which creates resolve/reject actions automatically

export const accountDetailFetch = createAsyncThunk(
  GlobalFeatureNameSpaceNotary.DYNAMIC_TABS + '/AccountDetailFetch',
  async entityId => {
    const entityRes = await ApiService().getEntity(entityId)
    return entityRes
  }
)

export const lineChartDataByLocationFetch = createAsyncThunk(
  GlobalFeatureNameSpaceNotary.DYNAMIC_TABS + '/LineChartDataByLocationFetch',
  async data => {
    const res = await ApiService().getLineChartDataByid(data.id)

    return res
  }
)

export const lineChartDataByDateFetch = createAsyncThunk(
  GlobalFeatureNameSpaceNotary.DYNAMIC_TABS + '/LineChartDataByDateFetch',
  async data => {
    const res = await ApiService().getLineChartDataByDateRange(
      data.id,
      data.fromDate,
      data.toDate
    )
    return res
  }
)

export const commentByDateFetch = createAsyncThunk(
  GlobalFeatureNameSpaceNotary.DYNAMIC_TABS + '/CommentByDateFetch',
  async (id, selectedDate) => {
    const res = await ApiService().getCommentByDate(id, selectedDate)

    return res
  }
)
